import { CapoPlugin } from "/Applications/FE/front/paxgon/node_modules/.pnpm/@unhead+vue@1.11.20_vue@3.5.16_typescript@5.8.3_/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];